import { apiRequest } from '@/core';
import { type AcceptInvitePayload } from '@/slices/members/types';

export const acceptInviteRequest = async (member: AcceptInvitePayload) =>
  apiRequest<void>({
    endpoint: `api/members/invite/accept`,
    method: 'POST',
    body: member,
  });
